<template>
    <div class="design-card col-md-6">
        <div class="design-card-header">
            <div class="design-card-title-section">
                <h3 class="design-card-title">
                    {{ design.name || "Untitled Design" }}
                </h3>
                <p v-if="design.created_at" class="design-card-date">
                    Uploaded On {{ formatDate(design.created_at) }}
                </p>
            </div>
            <button class="btn view_design_btn" @click="handleViewDesign">
                View Design
            </button>
        </div>

        <div class="design-card-images">
            <div v-if="design.front_image" class="design-image-item">
                <div class="design-image-wrapper">
                    <img
                        :src="getImageUrl(design.front_image)"
                        alt="Front"
                        class="design-image"
                    />
                    <button
                        class="add_artwork_preview_popup_btn seen"
                        @click="openImageModal(design.front_image, 'Front')"
                        title="View Front Image"
                    >
                        <img src="/maincss/images/preview.svg" alt="" />
                    </button>
                </div>
                <div class="design-image-label">FRONT</div>
                <div
                    v-if="getFrontColors().length > 0"
                    class="design-color-swatches"
                >
                    <div
                        v-for="(color, index) in getFrontColors()"
                        :key="index"
                        class="color-swatch"
                        :style="{ backgroundColor: color }"
                        :title="color"
                    ></div>
                </div>
                <div v-else class="design-radio-wrapper">
                    <input
                        type="radio"
                        :name="'design-' + design.id + '-front'"
                        class="design-radio"
                    />
                </div>
            </div>

            <div v-if="design.back_image" class="design-image-item">
                <div class="design-image-wrapper">
                    <img
                        :src="getImageUrl(design.back_image)"
                        alt="Back"
                        class="design-image"
                    />
                    <button
                        class="add_artwork_preview_popup_btn seen"
                        @click="openImageModal(design.back_image, 'Back')"
                        title="View Back Image"
                    >
                        <img src="/maincss/images/preview.svg" alt="" />
                    </button>
                </div>
                <div class="design-image-label">BACK</div>
                <div
                    v-if="getBackColors().length > 0"
                    class="design-color-swatches"
                >
                    <div
                        v-for="(color, index) in getBackColors()"
                        :key="index"
                        class="color-swatch"
                        :style="{ backgroundColor: color }"
                        :title="color"
                    ></div>
                </div>
                <div v-else class="design-radio-wrapper">
                    <input
                        type="radio"
                        :name="'design-' + design.id + '-back'"
                        class="design-radio"
                    />
                </div>
            </div>

            <div v-if="design.left_image" class="design-image-item">
                <div class="design-image-wrapper">
                    <img
                        :src="getImageUrl(design.left_image)"
                        alt="Left"
                        class="design-image"
                    />
                    <button
                        class="add_artwork_preview_popup_btn seen"
                        @click="openImageModal(design.left_image, 'Left')"
                        title="View Left Image"
                    >
                        <img src="/maincss/images/preview.svg" alt="" />
                    </button>
                </div>
                <div class="design-image-label">LEFT</div>
                <div
                    v-if="getLeftColors().length > 0"
                    class="design-color-swatches"
                >
                    <div
                        v-for="(color, index) in getLeftColors()"
                        :key="index"
                        class="color-swatch"
                        :style="{ backgroundColor: color }"
                        :title="color"
                    ></div>
                </div>
                <div v-else class="design-radio-wrapper">
                    <input
                        type="radio"
                        :name="'design-' + design.id + '-left'"
                        class="design-radio"
                    />
                </div>
            </div>

            <div v-if="design.right_image" class="design-image-item">
                <div class="design-image-wrapper">
                    <img
                        :src="getImageUrl(design.right_image)"
                        alt="Right"
                        class="design-image"
                    />
                    <button
                        class="add_artwork_preview_popup_btn seen"
                        @click="openImageModal(design.right_image, 'Right')"
                        title="View Right Image"
                    >
                        <img src="/maincss/images/preview.svg" alt="" />
                    </button>
                </div>
                <div class="design-image-label">RIGHT</div>
                <div
                    v-if="getRightColors().length > 0"
                    class="design-color-swatches"
                >
                    <div
                        v-for="(color, index) in getRightColors()"
                        :key="index"
                        class="color-swatch"
                        :style="{ backgroundColor: color }"
                        :title="color"
                    ></div>
                </div>
                <div v-else class="design-radio-wrapper">
                    <input
                        type="radio"
                        :name="'design-' + design.id + '-right'"
                        class="design-radio"
                    />
                </div>
            </div>
        </div>

        <!-- Image Preview Modal -->
        <div
            class="modal fade cart_preview"
            :id="'designImageModal-' + design.id"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-xl upload_img_popup add_design_modal"
            >
                <div class="modal-content">
                    <div class="modal-header border-bottom-0">
                        <button
                            type="button"
                            class="close py-2 pr-3"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="closeImageModal"
                        >
                            <img src="/maincss/images/cancel.svg" />
                        </button>
                    </div>
                    <div class="modal-body pt-0">
                        <div class="mx-auto preview-image mb_20">
                            <img
                                v-if="modalImageUrl"
                                :src="modalImageUrl"
                                :alt="modalImageLabel"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
    name: "DesignCard",
    props: {
        design: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            modalImageUrl: "",
            modalImageLabel: ""
        };
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return "";
            const date = new Date(dateString);
            const months = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ];
            return `${
                months[date.getMonth()]
            } ${date.getDate()}, ${date.getFullYear()}`;
        },
        getImageUrl(imagePath) {
            if (!imagePath) return "";
            if (this.isValidHttpUrl(imagePath)) {
                return imagePath;
            }
            return ApiService.apiBaseUrl() + "server" + imagePath;
        },
        isValidHttpUrl(string) {
            if (!string) return false;
            let url;
            try {
                url = new URL(string);
            } catch (_) {
                return false;
            }
            return url.protocol === "http:" || url.protocol === "https:";
        },
        isJSON(str) {
            try {
                JSON.parse(str);
                return true;
            } catch (error) {
                return false;
            }
        },
        parseColors(colors) {
            const colorArray = [];
            if (!colors || colors === null || colors === "null") {
                return colorArray;
            }
            // If it's a JSON string, parse it
            if (this.isJSON(colors)) {
                try {
                    const colorsParse = JSON.parse(colors);
                    if (Array.isArray(colorsParse) && colorsParse.length > 0) {
                        // Limit to 4 colors max
                        const limitColorsArr =
                            colorsParse.length > 4
                                ? colorsParse.slice(0, 4)
                                : colorsParse;

                        limitColorsArr.forEach((element) => {
                            let colorHex = "";
                            // Handle different color formats
                            if (typeof element === "string") {
                                colorHex = element;
                            } else if (element && element.hex) {
                                colorHex = element.hex;
                            } else if (element && typeof element === "object") {
                                colorHex =
                                    element.hex ||
                                    element.color ||
                                    element.value ||
                                    "";
                            }

                            // Format color hex properly
                            if (colorHex) {
                                // Add # if missing and it's a hex code
                                if (
                                    !colorHex.startsWith("#") &&
                                    /^[0-9A-Fa-f]{6}$/.test(colorHex)
                                ) {
                                    colorHex = "#" + colorHex;
                                }
                                // Only add valid color formats
                                if (
                                    colorHex.startsWith("#") ||
                                    colorHex.match(/^[a-zA-Z]+$/)
                                ) {
                                    colorArray.push(colorHex);
                                }
                            }
                        });
                    }
                } catch (e) {
                    console.error("Error parsing colors:", e);
                }
            } else if (typeof colors === "string" && colors.trim() !== "") {
                // If it's a simple string color, use it directly
                let colorHex = colors.trim();
                if (
                    !colorHex.startsWith("#") &&
                    /^[0-9A-Fa-f]{6}$/.test(colorHex)
                ) {
                    colorHex = "#" + colorHex;
                }
                if (colorHex.startsWith("#") || colorHex.match(/^[a-zA-Z]+$/)) {
                    colorArray.push(colorHex);
                }
            }

            return colorArray;
        },
        getFrontColors() {
            return this.parseColors(this.design.front_color);
        },
        getBackColors() {
            return this.parseColors(this.design.back_color);
        },
        getLeftColors() {
            return this.parseColors(this.design.left_color);
        },
        getRightColors() {
            return this.parseColors(this.design.right_color);
        },
        handleViewDesign() {
            // Check if product session exists
            const productValues = localStorage.getItem("product_values");
            const productId = localStorage.getItem("product_id");
            if (!productValues && !productId) {
                // No active design session - show modal with custom message
                /* eslint-disable */
                this.$nextTick(() => {
                    // Set data attribute for message type
                    $("#design-studio").data("message-type", "no-session");
                    $("#design-studio").modal("show");
                });
                /* eslint-enable */
            } else {
                // Navigate to Design Studio with My Designs tab open and design history
                this.$router.push({
                    name: "DesignStudioV3",
                    hash: "#designs",
                    query: { designHistoryId: this.design.id }
                });
            }
        },
        openImageModal(imagePath, label) {
            this.modalImageUrl = this.getImageUrl(imagePath);
            this.modalImageLabel = label;
            /* eslint-disable */
            this.$nextTick(() => {
                $("#designImageModal-" + this.design.id).modal("show");
            });
            /* eslint-enable */
        },
        closeImageModal() {
            /* eslint-disable */
            this.$nextTick(() => {
                $("#designImageModal-" + this.design.id).modal("hide");
            });
            /* eslint-enable */
        }
    }
};
</script>

<style scoped>
.design-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 0px;
    box-shadow: 2px 4px 25px rgba(0, 0, 0, 0.1);
    position: relative;
}

.design-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
}

.design-card-title-section {
    flex: 1;
}

.design-card-title {
    font-size: 20px;
    font-weight: bold;
    color: #2b2b2b;
    margin: 0 0 8px 0;
}

.design-card-date {
    font-size: 14px;
    color: #888888;
    margin: 0;
}

.design-card-delete-btn {
    background: #ff0000;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    text-transform: uppercase;
    transition: background 0.3s;
}

.design-card-delete-btn:hover {
    background: #cc0000;
}

.design-card-images {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.design-image-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0 0 auto;
}

.design-image-wrapper {
    width: 120px;
    height: 120px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    position: relative;
}

button.add_artwork_preview_popup_btn {
    z-index: 1;
    position: relative;
}

.design-image-wrapper .seen {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: absolute !important;
    display: none;
    border: none;
    background: #fff;
    border-radius: 12px;
    padding: 8px;
    cursor: pointer;
}

.design-image-wrapper:hover .seen {
    display: block;
}

.design-image-wrapper .seen img {
    width: 50px !important;
    height: auto;
    display: block;
}

.design-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.design-image-label {
    font-size: 12px;
    font-weight: 600;
    color: #2b2b2b;
    margin-bottom: 8px;
    text-transform: uppercase;
}

.design-color-swatches {
    display: flex;
    gap: 0px;
    align-items: center;
}

.color-swatch {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid #101010;
    cursor: pointer;
    transition: transform 0.2s;
    margin-right: -4px;
}

.color-swatch:hover {
    transform: scale(1.1);
}

.design-radio-wrapper {
    margin-top: 8px;
}

.design-radio {
    width: 16px;
    height: 16px;
    cursor: pointer;
}
.view_design_btn {
    border-color: #f2790c !important;
    background-color: #f2790c !important;
    background: #f2790c;
    gap: 8px;
    padding: 7px 12px;
    border-radius: 6px;
    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
}
.add_design_modal .modal-content .preview-image img {
        object-fit: none;
        margin-top: 0px;
}
/* Modal uses cart_preview class from main CSS - no custom styles needed */
@media (max-width: 768px) {
    .design-card-images {
        flex-direction: column;
        align-items: center;
    }

    .design-image-item {
        width: 100%;
        max-width: 200px;
    }
}
</style>